export default __webpack_public_path__ + "static/banner-three-main-img-792f4539ac05569409c95585ccaa616e.png";